import { PaymentMethodSettings } from '@data/models';
import { apiCall } from '../axios';
import { getExternalPaymentBaseUrl } from '../../../config';
export class PaymentSettingsService {
    // Mirrors the SDK's own request to /payment/PaymentElement/v2/settings so the
    // eligible methods match what the inline <PaymentElement> would render.
    static fetchSettings({ apiKey, isCfar, paymentMethodFilters, propertyId, }) {
        return new Promise((resolve, reject) => {
            const url = `${getExternalPaymentBaseUrl()}/payment/PaymentElement/v2/settings`;
            apiCall(PaymentMethodSettings)('post', url, {
                is_cfar: isCfar !== null && isCfar !== void 0 ? isCfar : false,
                origin: window.location.origin,
                payment_method_filters: paymentMethodFilters !== null && paymentMethodFilters !== void 0 ? paymentMethodFilters : [],
                property_id: propertyId,
            }, {
                contentType: 'application/json',
                headers: { Authorization: `Bearer ${apiKey}` },
            })
                .then((settings) => {
                if (!settings.success) {
                    reject(new Error('Payment settings request was not successful'));
                    return;
                }
                resolve(settings);
            })
                .catch(reject);
        });
    }
}
